import { useEffect, useState } from "react";

import styles from "./RegisterForTest.module.scss";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { createNewUser } from "service/AdminService";
import { postRegisterUser } from "store/slices/AdminSlice";
import Notification from "utils/Notifications";
import eye from 'assets/icons/eye.png'
import hidden from 'assets/icons/hidden.png'
import { getUserInfo } from "service/AuthService";
import { changePinCode, setUser } from "store/slices/UserSlice";
import tokenDecode from "utils/decode";

import { ScaleLoader } from "react-spinners";
import { Button } from "components";
import ModalWindow from "hooks/ModalWindow/ModalWindow";
import {
  checkPinCode,
} from "service/AuthService";
import PinCode from "hooks/PinCode/PinCode";
import {
  ChangePin,
  SendDevice,
  login,
} from "service/AuthService";
import { useNavigate } from "react-router-dom";


const RegisterForTest = ({ setLoginMail, RecoverPin }) => {
  const { t } = useTranslation();
  const [loader, setLoader] = useState(false);
  const [gender, setGender] = useState(null);
  const [first_name, setFirst_name] = useState(null);
  const [last_name, setLast_name] = useState(null);
  const [middle_name] = useState("");
  const [data_of_birth] = useState(null);
  const [number_phone, setNumber_phone] = useState(null);
  const [email, setEmail] = useState(null);
  const [inn, setInn] = useState(null);
  const [password, setPassword] = useState(null);
  const [checkPassword, setCheckPassword] = useState(null);
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();
  const [openModal, setOpenModal] = useState(false);
  const [datainfo, setDataInfo] = useState(false);
  const [userPinCode, setUserPinCode] = useState();
  const [pinCode, setPinCode] = useState();
  const [userId, setUserId] = useState();
  const [device, setDevice] = useState("");

  useEffect(() => {
    const userAgent = window.navigator.userAgent;
    setDevice(userAgent);
  }, []);
  let socket = null;

  const sendMessage = (message) => {
    if (socket && socket.readyState === WebSocket.OPEN) {
      socket.send(message);
    }
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const [notify, setNotify] = useState({
    isOpen: false,
    message: "",
    type: "",
  });
  const dispatch = useDispatch();
  const isValidEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(String(email).toLowerCase());
  };

  const pinLogIn = async () => {
    localStorage.setItem("mute", "false");

    if (String(pinCode).length === 4) {
      setLoader(true);
      try {
        const response = await checkPinCode(pinCode, userId);
        if (response.data.success) {
          setNotify({
            isOpen: true,
            message: t("auth.welcome", "Добро пожаловать!"),
            type: "success",
          });

          const socket = new WebSocket("wss://sys.chu.kg/ws/online_status/");
          socket.onopen = () => {
            socket.send(JSON.stringify({ command: "connect", user_id: userId }));
            socket.close();
          };

          await SendDevice(device);

          setUserId(datainfo.user);
          sendMessage({ user_id: userId });
          dispatch(setUser(datainfo));

          setTimeout(() => {
            window.location.href = `/post-login/`;
          }, 1000);
        } else {
          setNotify({
            isOpen: true,
            message: t("auth.wrong_pin", "Неправильный Пин-Код"),
            type: "error",
            sound: "error",
          });
        }
      } catch (error) {
        setNotify({
          isOpen: true,
          message: t("common.server_error_retry", "Ошибка сервера. Попробуйте позже."),
          type: "error",
          sound: "error",
        });
      } finally {
        setLoader(false);
      }
    } else {
      setNotify({
        isOpen: true,
        message: t("auth.enter_4_pin", "Введите 4-значный ПИН-код"),
        type: "warning",
      });
    }
  };

  const createUserPin = async () => {
    if (String(pinCode)?.length < 4 || !pinCode) {
      setNotify({
        isOpen: true,
        message: t("auth.enter_pin", "Введите Пин!"),
        type: "error",
        sound: "error",
      });
    } else if (String(pinCode).length === 4) {
      try {
        setLoader(true);

        await ChangePin(pinCode);
        dispatch(
          changePinCode({
            pin: pinCode,
          })
        );
        setTimeout(() => {
          setNotify({
            isOpen: true,
            message: t("auth.pin_set", "Пин успешно задан"),
            type: "success",
            sound: "success",
          });
        }, 1000);

        setNotify({
          isOpen: true,
          message: t("auth.welcome", "Добро пожаловать!"),
          type: "success",
          sound: "success",
        });
        setTimeout(async () => {
          await SendDevice(device);

          setUserId(datainfo.user);
          sendMessage({ user_id: userId });
          dispatch(setUser(datainfo));
          setTimeout(() => {
            navigate(`/post-login/`);
          }, 2000);
        }, 1000);
      } catch (error) {
        setNotify({
          isOpen: true,
          message: t("common.error", "Ошибка"),
          type: "error",
          sound: "error",
        });
      }
    }
  };


  const handleSubmit = async (event) => {
    event.preventDefault();
    if (loader) return;
    if (
      !first_name ||
      !last_name ||
      !number_phone ||
      !inn ||
      !password
    ) {
      setNotify({
        isOpen: true,
        message: t("common.fill_all_fields", "Заполните все поля!"),
        type: "warning",
        sound: "warning",
      });
      return;
    }
    if (!email || !isValidEmail(email)) {
      setNotify({
        isOpen: true,
        message: t("auth.invalid_email", "Указанная вами электронная почта не верна!"),
        type: "warning",
        sound: "warning",
      });
      return;
    }
    if (inn.length < 5) {
      setNotify({
        isOpen: true,
        message: t("auth.inn_too_short", "ИНН слишком короткий"),
        type: "warning",
        sound: "warning",
      });
      return;
    }
    if (password.length < 8) {
      setNotify({
        isOpen: true,
        message: t("auth.password_too_short", "Пароль должен содержать минимум 8 символов"),
        type: "warning",
        sound: "warning",
      });
      return;
    }
    if (checkPassword !== password) {
      setNotify({
        isOpen: true,
        message: t("auth.password_mismatch", "Пароль не совпадает!"),
        type: "warning",
        sound: "warning",
      });
      return;
    }
    try {
        setLoader(true);
        // SECURITY (Wave 2A hotfix): убран фейк-логин logintrash('free','free').
        // Регистрация теперь идёт публично (createNewUser должен принимать AllowAny),
        // после успеха — реальный login() с введёнными данными.
        let response = await createNewUser(
          gender,
          first_name,
          last_name,
          middle_name,
          data_of_birth,
          number_phone,
          email,
          inn,
          password
        );

        if (response?.data?.message) {
          setNotify({
            isOpen: true,
            message: response?.data?.message,
            type: "error",
            sound: "error",
          });
        }
        else {
          dispatch(
            postRegisterUser({
              gender,
              first_name,
              last_name,
              middle_name,
              data_of_birth,
              number_phone,
              email,
              inn,
              password,
            })
          );

          const delay = 1000;
          setTimeout(() => {
            const signIn = async () => {
              localStorage.removeItem("task");
              localStorage.removeItem("user");
              let responseinfo = await login(inn, password);

              localStorage.setItem("token", responseinfo.data.access);
              const userId = tokenDecode(responseinfo.data.refresh);

              let userResponse = await getUserInfo(userId);
              const data = { ...userResponse.data, token: responseinfo.data.access };

              setUserPinCode(data.pin);
              setDataInfo(data);
              setOpenModal(true);
              setUserId(userId);
            };
            signIn();
          }, delay);
        }
      } catch (error) {
        setNotify({
          isOpen: true,
          message: t("common.error", "Ошибка!"),
          type: "error",
          sound: "error",
        });
      } finally {
        setLoader(false);
      }
  };

  const forSelect = useSelector((state) => state.order.position);

  const handleInputChange = (e) => {
    let value = e.target.value;
    value = value.replace(/[^\d]/g, '');
    setInn(value);
  };

  return (
    <>
      <div className={`${styles.container} unv-form-card`}>
        <h2 className={`${styles.login__title} unv-form-card__title`}>
          {t("auth.welcome_register", "Рады видеть вас в CHU!")}
        </h2>
        <h4 className={`${styles.login__untitle} unv-form-card__subtitle`}>
          {t("auth.fill_data", "Пожалуйста, заполните свои данные")}
        </h4>
        <form onSubmit={handleSubmit} noValidate>
          <div className={styles.user_details}>
            <div className={styles.input_pox} style={{ width: '100%' }}>
              <label className={styles.datails} htmlFor="rt-inn">{t("auth.inn", "ИНН")}</label>
              <input
                id="rt-inn"
                type="text"
                inputMode="numeric"
                pattern="[0-9]*"
                autoComplete="username"
                placeholder={t("auth.inn", "ИНН")}
                value={inn ?? ''}
                onChange={handleInputChange}
                required
              />
            </div>
            <div className={styles.input_pox}>
              <label className={styles.datails} htmlFor="rt-last-name">{t("user.last_name", "Фамилия")}</label>
              <input
                id="rt-last-name"
                type="text"
                autoComplete="family-name"
                placeholder={t("user.last_name", "Фамилия")}
                value={last_name ?? ''}
                onChange={(e) => setLast_name(e.target.value)}
                required
              />
            </div>
            <div className={styles.input_pox}>
              <label className={styles.datails} htmlFor="rt-first-name">{t("user.first_name", "Имя")}</label>
              <input
                id="rt-first-name"
                type="text"
                autoComplete="given-name"
                placeholder={t("user.first_name", "Имя")}
                value={first_name ?? ''}
                onChange={(e) => setFirst_name(e.target.value)}
                required
              />
            </div>

            <div className={styles.input_pox}>
              <label className={styles.datails} htmlFor="rt-phone">{t("user.phone", "Номер телефона")}</label>
              <input
                id="rt-phone"
                type="tel"
                inputMode="numeric"
                pattern="[0-9]*"
                autoComplete="tel"
                placeholder={t("user.phone", "Номер телефона")}
                value={number_phone ?? ''}
                onChange={(e) => setNumber_phone(e.target.value.replace(/\D/g, ''))}
                required
              />
            </div>
            <div className={styles.input_pox}>
              <label className={styles.datails} htmlFor="rt-email">{t("user.email", "E-mail")}</label>
              <input
                id="rt-email"
                type="email"
                autoComplete="email"
                placeholder={t("user.email_placeholder", "Электронная почта")}
                value={email ?? ''}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>

            <div className={styles.input_pox}>
              <label className={styles.datails} htmlFor="rt-password">{t("auth.password", "Пароль")}</label>
              <input
                id="rt-password"
                type={showPassword ? "text" : "password"}
                autoComplete="new-password"
                minLength={8}
                placeholder={t("auth.password", "Пароль")}
                value={password ?? ''}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
              <button
                type="button"
                className={styles.show__password}
                onClick={togglePasswordVisibility}
                aria-label={showPassword ? t("auth.hide_password", "Скрыть пароль") : t("auth.show_password", "Показать пароль")}
              >
                {showPassword ? <img src={hidden} alt="" /> : <img src={eye} alt="" />}
              </button>
            </div>
            <div className={styles.input_pox}>
              <label className={styles.datails} htmlFor="rt-password-confirm">{t("auth.repeat_password", "Повторите пароль")}</label>
              <input
                id="rt-password-confirm"
                type={showPassword ? "text" : "password"}
                autoComplete="new-password"
                minLength={8}
                placeholder={t("auth.password", "Пароль")}
                value={checkPassword ?? ''}
                onChange={(e) => setCheckPassword(e.target.value)}
                required
              />
            </div>
          </div>

          {loader ? (
            <ScaleLoader color="black" size={30} />
          ) : (
            <div className={styles.button}>
              <button
                type="submit"
                disabled={loader}
              >
                {t("auth.register", "Зарегистрироваться")}
              </button>
            </div>
          )}
        </form>
        <h4 className={styles.login__untitle} style={{ marginTop: "10px" }}>
          {t("auth.consent", "Регистрируясь, вы подтверждаете, что принимаете Пользовательское соглашение, даете Поручение и Согласие на обработку персональных данных.")}
        </h4>
        <hr className={styles.hr__line}></hr>
        <div className={styles.register_footer}>
          {t("auth.have_account", "У вас уже есть аккаунт?")}
          <button
            type="button"
            className={styles.register_button_create}
            onClick={() => setLoginMail(false)}
          >
            {t("auth.signin", "Войти")}
          </button>
        </div>
      </div>

      <Notification notify={notify} setNotify={setNotify} />
      {userPinCode === null ? (
        <ModalWindow
          openModal={openModal}
          setOpenModal={setOpenModal}
          modalTitle={
            <p>{t("auth.welcome_chu_full", "Добро пожаловать в CHU!")}</p>
          }
          modalText={t("auth.create_pin", "Придумайте ПИН-код")}
          width={"unset"}
        >
          <PinCode setPinCode={setPinCode} passwordVisible={false} />

          {loader ? (
            <Button
              type="button"
              style={{ width: "unset", border: "none", background: "none" }}
            >
              <ScaleLoader color="black" size={15} />
            </Button>
          ) : (
            <>
              <Button
                type="button"
                onClick={() => setOpenModal(false)}
                className={styles.btn_pin_close}
              >
                {t("common.close", "Закрыть")}
              </Button>
              <Button
                type="button"
                style={{ width: "unset" }}
                onClick={createUserPin}
                disabled={loader}
                className={styles.btn_pin}
              >
                {t("common.save", "Сохранить")}
              </Button>
            </>
          )}
        </ModalWindow>
      ) : (
        <ModalWindow
          openModal={openModal}
          setOpenModal={setOpenModal}
          modalText={t("auth.enter_pin", "Введите ПИН-код")}
          width={"unset"}
        >
          <>
            <PinCode setPinCode={setPinCode} passwordVisible={false} />
            <Button
              type="button"
              onClick={() => setOpenModal(false)}
              className={styles.btn_pin_close}
            >
              {t("common.close", "Закрыть")}
            </Button>
            <Button type="button" onClick={pinLogIn} disabled={loader} className={styles.btn_pin}>
              {t("auth.signin", "Войти")}
            </Button>
          </>
          <div className={styles.div_register_button} style={{ marginTop: '5px' }}>
            <button
              type="button"
              className={styles.register_button_reset}
              onClick={() => RecoverPin()}
              style={{ margin: "0px 10px 0px 0" }}
            >
              {t("auth.forgot_pin", "Забыли пин?")}
            </button>
          </div>
        </ModalWindow>
      )}
    </>
  );
};

export default RegisterForTest;
